import MainRoutingPage from './component/MainRoutingPage';
import HomePage from './component/pages/HomePage';

function App() {
  return (
    <>
    {/* <HomePage/> */}
    <MainRoutingPage/>
     </>
  );
}

export default App;
